import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { Languages } from "lucide-react";

export function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <button onClick={toggle} data-testid="language-toggle-button"
      className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition-all hover:border-primary hover:text-primary active:scale-95 ${className}`}>
      <Languages className="h-4 w-4" />
      <span>{lang === "ar" ? "EN" : "عربي"}</span>
    </button>
  );
}
